import { Row } from "antd";
import PhysicalActivityCalendar from "../Calendar/PhysicalActivityCalendar";

const PatientPhysicalActivityTable = () => {
  return (
    <Row className="relative my-14 w-full">
      <PhysicalActivityCalendar />
    </Row>
  );
};

export default PatientPhysicalActivityTable;
